import { Navigate, RouteObject } from 'react-router-dom';
import { ProtectedBase } from '../components/sections';
import { DashboardPage } from '../features/dashboard/page';
import AdminPage from '../features/auth/page/AdminPage';
import { CheckOutSuccess } from '../features/dashboard/components';
import { TreeRoutes } from '../features/family-tree/routes/treeRoutes';
import ProfileSettings from '../features/auth/page/Settings';

export const protectedRoutes: RouteObject[] = [
  {
    path: '/app',
    element: <ProtectedBase />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'tree/*',
        element: <TreeRoutes />,
      },
      {
        path: 'settings',
        element: <ProfileSettings />,
      },
      {
        path: 'admin',
        element: <AdminPage />,
      },
      {
        path: 'success',
        element: <CheckOutSuccess />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
];
